module.exports = __webpack_public_path__ + "static/media/Email_Icon.098f2347.svg";